require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-dan-kavanaugh-financial-center-chief-sales-and-marketing-officer-retires.json") })
        }
      }, "path---articles-dan-kavanaugh-financial-center-chief-sales-and-marketing-officer-retires");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-dan-kavanaugh-financial-center-chief-sales-and-marketing-officer-retires!./.cache/json/articles-dan-kavanaugh-financial-center-chief-sales-and-marketing-officer-retires.json
// module id = 1579
// module chunks = 231608221292675